import { registerMutation, useMutation } from 'data-fetching-client';
import { useCallback } from 'react';
import { GET_TICKET } from './useTicket';
import { GET_TICKET_LISTING_KEY } from './useTicketListings';
import { api } from '../utils/api';
import { TICKET_CLOSE_BASE_PATH } from '../../api/paths';
const closeTicket = async ({
  id
}) => {
  const res = await api(`${TICKET_CLOSE_BASE_PATH}/${id}`, {
    method: 'POST',
    headers: {
      'X-HS-User-Request': '1'
    }
  });
  if (!res.ok) {
    throw new Error(`Close ticket error: ${res.status} - ${res.statusText}`);
  }
  // Returning minimal data since close endpoint returns (204 - No Content)
  return {
    id,
    status: 'CLOSED'
  };
};
const CLOSE_TICKET_MUTATION_FIELD_NAME = 'closeTicket';
const CLOSE_TICKET_MUTATION = registerMutation({
  fieldName: CLOSE_TICKET_MUTATION_FIELD_NAME,
  fetcher: closeTicket,
  args: ['id']
});
export const useCloseTicket = () => {
  const [mutate, {
    loading,
    called,
    error
  }] = useMutation(CLOSE_TICKET_MUTATION, {
    refetchQueries: [GET_TICKET],
    awaitRefetchQueries: true,
    update: cache => {
      cache.evict({
        fieldName: GET_TICKET_LISTING_KEY
      });
      cache.gc(); // recommended by Apollo https://www.apollographql.com/docs/react/caching/garbage-collection/#cacheevict
    }
  });
  const handleCloseTicket = useCallback(id => {
    return mutate({
      variables: {
        id
      }
    });
  }, [mutate]);
  return {
    closeTicket: handleCloseTicket,
    isTicketClosing: loading,
    isCompleted: called && !loading,
    error
  };
};